import Vue from 'vue'
import Vuex from "vuex"
import api from "@/api"

Vue.use(Vuex)
export var store = new Vuex.Store({
    state: {
        fileIp: "",
        //亦廉课堂详情数据
        ClassroomListD:{},
        outsideActive:"first",
    },
    mutations: {
        SET_FILEIP(state, fileIp) {
            state.fileIp = fileIp
            // console.log(state.fileIp,222)
        },
        setclassList(state,ClassroomListD){
            state.ClassroomListD = ClassroomListD
            // console.log(state.ClassroomListD,"mutations中的打印")
        },
        SET_OUTSIDE_ACTIVE(state,outsideActive){
            state.outsideActive = outsideActive
            // console.log(state.ClassroomListD,"mutations中的打印")
        },

    },
    actions: {
        SET_FILEIP({ commit }) {
            return new Promise((resolve) => {
                api.getIp().then(res => {
                    commit('SET_FILEIP', res.data)
                    resolve();
                });
            })
        },

    }
})